import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle, Platform } from 'react-native';
import { colors } from '../theme/colors';

type Variant = 'light' | 'dark';
type Size = 'sm' | 'md' | 'lg';

type Props = {
  /** light = white Goal on dark backgrounds; dark = dark Goal on light backgrounds */
  variant?: Variant;
  size?: Size;
  /** Center the wordmark horizontally (e.g. auth logo block) */
  centered?: boolean;
  style?: ViewStyle;
};

const FONT_SIZES: Record<Size, number> = {
  sm: 22,
  md: 26,
  lg: 36,
};

/**
 * Two-tone GoalMint on a single line (Goal + Mint never wraps to a second line).
 */
const BrandWordmark = ({ variant = 'light', size = 'md', centered = false, style }: Props) => {
  const fontSize = FONT_SIZES[size];
  const goalColor = variant === 'light' ? '#FFFFFF' : colors.text.primary;

  return (
    <View style={[styles.row, centered && styles.rowCentered, style]} accessibilityRole="text">
      <Text
        style={[styles.part, { fontSize, color: goalColor }, Platform.OS === 'web' && styles.nowrapWeb]}
        numberOfLines={1}
      >
        Goal
      </Text>
      <Text
        style={[styles.part, { fontSize, color: colors.brand.accent }, Platform.OS === 'web' && styles.nowrapWeb]}
        numberOfLines={1}
      >
        Mint
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    alignSelf: 'flex-start',
    maxWidth: '100%',
  },
  rowCentered: {
    alignSelf: 'center',
  },
  part: {
    fontWeight: '700',
    letterSpacing: 0.5,
    flexShrink: 0,
  },
  nowrapWeb: {
    whiteSpace: 'nowrap',
  } as TextStyle,
});

export default BrandWordmark;
